export const ROLES = {
  ADMINISTRATIVO: "administrativo",
  AGENCIA: "agencia",
  BOARD: "board",
  CLIENTE: "cliente",
  COMERCIAL: "comercial",
  EDIFICIO: "edificio",
  GERENCIA: "gerencia",
  SUPERADMIN: "superadmin",
};
